// @flow

import styled from 'styled-components';
import { LinkStyled } from '../../../../link';
import type { Theme } from '../../../../../types';
import type { ReviewTemplate } from '../../../types';

type Props = {
  template: ReviewTemplate,
};

export default styled<typeof LinkStyled, Theme, Props>(LinkStyled)`
  color: ${props => props.theme.review[props.template].reviewLink.main};

  &:hover {
    color: ${props => props.theme.review[props.template].reviewLink.hover};
  }

  &:visited {
    color: ${props => props.theme.review[props.template].reviewLink.visited};
  }

  &:focus,
  &:active {
    color: ${props => props.theme.review[props.template].reviewLink.active};
  }
`;
